import { ReactElement } from 'react';
import {
  FieldErrors,
  UseFormRegisterReturn,
  UseFormSetValue,
} from 'react-hook-form';
import { ValueType } from 'react-select';
import { ButtonOrSvgClickEventHandlerI } from '@root/src/app/designSystem/buttons';
import { OrderDetailsI } from '@app/healthcheck/order/types';
import useWindowWidth from '@app/common/useWindowWidth';
import EditPersonalDesktop from './editPersonalDesktop';
import EditPersonalMobile from './editPersonalMobile';
import { FormData } from './types';
import { SelectOption } from '@app/common/types';

type EditOrderGeneralProps = {
  handleClose: ButtonOrSvgClickEventHandlerI;
  handleSaveOrderInformation?: ButtonOrSvgClickEventHandlerI;
  handleSavePersonalInformation?: ButtonOrSvgClickEventHandlerI;
  errors?: FieldErrors<FormData>;
};

export type EditPersonalProps = EditOrderGeneralProps & {
  months: SelectOption[];
  currentValueMonth: SelectOption;
  handleChangeMonth: (e: ValueType<SelectOption, false>) => void;
  docTypes: SelectOption[];
  currentValueDocType: SelectOption;
  handleChangeDocType: (e: ValueType<SelectOption, false>) => void;
  isOrderStatusDone?: boolean;
  personalRegisteredFields: Record<string, UseFormRegisterReturn>;
};

export type EditOrderI = EditPersonalProps & {
  data: OrderDetailsI;
  setValue: UseFormSetValue<FormData>;
  getValues: (label: string) => string;
};

const EditPersonal = (props: EditOrderI): ReactElement => {
  const { isMobileView } = useWindowWidth();

  return isMobileView ? (
    <EditPersonalMobile {...props} />
  ) : (
    <EditPersonalDesktop {...props} />
  );
};

export default EditPersonal;
